//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/LineDesigner.js";
import "../no/Object.js";
import "../no/Session.js";
let d=[[],[[["part","type"],"CreateDBFactoryNode",{R_:{node:"LineDesigner.DBFactoryNode"}},2,0],[["part"],"CreateDBFenceNode",{R_:{node:"LineDesigner.DBFenceNode"}},1,0],[["part"],"CreateDBPlatformEquipmentNode",{R_:{node:"LineDesigner.DBPlatformEquipmentNode"}},1,0],[["part"],"CreateDBConveyorNode",{R_:{node:"LineDesigner.DBConveyorNode"}},1,0],[["part"],"CreateDBFloorEquipmentNode",{R_:{node:"LineDesigner.DBFloorEquipmentNode"}},1,0],[["part"],"CreateDBColumnGridNode",{R_:{node:"LineDesigner.DBColumnGridNode"}},1,0],[["part"],"CreateDBStairwayEquipmentNode",{R_:{node:"LineDesigner.DBStairwayEquipmentNode"}},1,0],[["part"],"CreateDBNodeContainer",{R_:{node:"LineDesigner.DBNodeContainer"}},1,0],[["part"],"CreateDBFactoryCadGeoNode",{R_:{node:"LineDesigner.DBFactoryCadGeoNode"}},1,0]],[]];
SPLM.LineDesigner.DBNodeManager = class extends SPLM.Object{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.LineDesigner.DBNodeManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;